export default __webpack_public_path__ + "static/media/pink-logo-with-word.fc3b8d81.svg";